import {
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from "@material-ui/core";
import React ,{ useEffect} from "react";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  icon: {
    minWidth: "30px",
  },
}));
export default function ListItemLink({
  icon,
  primary,
  to,
  children,
  onClick,
  className,
  activeIcon,
  isActive,
  isChild,
}) {
  const classes = useStyles();
  const CustomLink = React.useMemo(
    () =>
      React.forwardRef((linkProps, ref) => (
        isChild ?
        <NavLink activeStyle={{ background: '#962013' }} ref={ref} to={to} {...linkProps} /> : 
        <NavLink ref={ref} to={to} {...linkProps} />
      )),
    [to]
  );

  return (
    to && (
      <ListItem
        button
        component={CustomLink}
        className={className && className}
        onClick={onClick && onClick}
      >
        <ListItemIcon className={classes.icon}>{isActive ? activeIcon : icon}</ListItemIcon>
        <ListItemText primary={primary} />
        {children}
      </ListItem>
    )
  );
}
